import { ModalOverlay, ModalOverlayProps } from '@chakra-ui/react';

export const CModalOverlay = ({ ...props }: ModalOverlayProps): JSX.Element => (
    <ModalOverlay {...props} bg="blackAlpha.700" />
);
